import { render, staticRenderFns } from "./EmployeeRegistryFileDocumentHistory.vue?vue&type=template&id=48f844ae&"
import script from "./EmployeeRegistryFileDocumentHistory.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistryFileDocumentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports